'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CONTENT_LIMIT_PRO_BASE = exports.CONTENT_LIMIT_REFERRAL_MULTIPLIER = exports.CONTENT_LIMIT_FREE_MAX = exports.CONTENT_LIMIT_FREE_BASE = exports.USER_IDLE_TIMEOUT_MILLISECONDS = exports.USER_IDLE_TIMEOUT_SECONDS = exports.SAFE_USER_PROPERTY_WHITELIST = exports.USER_UPDATE_BROADCAST_WHITELIST = exports.DEFAULT_AVATAR_SIZE = exports.GUEST_USER_ID = exports.STARTER_CONTENT_CREATOR_ID = exports.PUBLIC_USER_ID = exports.EMAIL_PREFERENCE_BUFFER_BITS = exports.EMAIL_PREFERENCE_ALL = exports.EMAIL_PREFERENCE_BITS = exports.USER_ONLINE_STATUS = exports.USER_STATUSES = exports.USER_ROLES = exports.USER_DISCONNECT = exports.USER_MARK_AS_DISCONNECTED = exports.USER_CONNECT = exports.USER_NAVIGATE = exports.USER_REFRESH = exports.USER_UPDATE = undefined;

var _lodash = require('lodash');

var USER_UPDATE = exports.USER_UPDATE = 'USER_UPDATE'; // Lib
var USER_REFRESH = exports.USER_REFRESH = 'USER_REFRESH';
var USER_NAVIGATE = exports.USER_NAVIGATE = 'USER_NAVIGATE';

var USER_CONNECT = exports.USER_CONNECT = 'USER_CONNECT';
var USER_MARK_AS_DISCONNECTED = exports.USER_MARK_AS_DISCONNECTED = 'USER_MARK_AS_DISCONNECTED';
var USER_DISCONNECT = exports.USER_DISCONNECT = 'USER_DISCONNECT';

var USER_ROLES = exports.USER_ROLES = {
    USER: 'USER',
    ADMIN: 'ADMIN',
    STAFF: 'STAFF',
    BETA: 'BETA'
};

var USER_STATUSES = exports.USER_STATUSES = {
    INVITED: 'INVITED',
    ACTIVE: 'ACTIVE',
    LOCKED: 'LOCKED'
};

var USER_ONLINE_STATUS = exports.USER_ONLINE_STATUS = {
    CONNECTED: 'CONNECTED',
    DISCONNECTED: 'DISCONNECTED',
    IDLE: 'IDLE'
};

var EMAIL_PREFERENCE_BITS = exports.EMAIL_PREFERENCE_BITS = {
    PRODUCT_UPDATES: 1,
    ACTIVITY_DIGEST: 1 << 1,
    SHARED_BOARDS: 1 << 2
};
// Expect to use no more than 8 bits for email preferences
var EMAIL_PREFERENCE_ALL = exports.EMAIL_PREFERENCE_ALL = (1 << 8) - 1;
// The buffer bits that we're currently not using but might in the future
var EMAIL_PREFERENCE_BUFFER_BITS = exports.EMAIL_PREFERENCE_BUFFER_BITS = EMAIL_PREFERENCE_ALL ^ (0, _lodash.sum)((0, _lodash.values)(EMAIL_PREFERENCE_BITS));

var PUBLIC_USER_ID = exports.PUBLIC_USER_ID = '_other';
var STARTER_CONTENT_CREATOR_ID = exports.STARTER_CONTENT_CREATOR_ID = '_default';
var GUEST_USER_ID = exports.GUEST_USER_ID = 'guest';

var DEFAULT_AVATAR_SIZE = exports.DEFAULT_AVATAR_SIZE = 30;

var USER_UPDATE_BROADCAST_WHITELIST = exports.USER_UPDATE_BROADCAST_WHITELIST = ['currentBoardId', 'name', 'status', 'image', 'email', 'onlineStatus'];
var SAFE_USER_PROPERTY_WHITELIST = exports.SAFE_USER_PROPERTY_WHITELIST = ['_id', 'subscription'].concat(USER_UPDATE_BROADCAST_WHITELIST);

// The time that a user can be idle for before being marked as disconnected
var USER_IDLE_TIMEOUT_SECONDS = exports.USER_IDLE_TIMEOUT_SECONDS = 4 * 60;
var USER_IDLE_TIMEOUT_MILLISECONDS = exports.USER_IDLE_TIMEOUT_MILLISECONDS = USER_IDLE_TIMEOUT_SECONDS * 1000;

var CONTENT_LIMIT_FREE_BASE = exports.CONTENT_LIMIT_FREE_BASE = 100;
var CONTENT_LIMIT_FREE_MAX = exports.CONTENT_LIMIT_FREE_MAX = 500;

var CONTENT_LIMIT_REFERRAL_MULTIPLIER = exports.CONTENT_LIMIT_REFERRAL_MULTIPLIER = 20;

// hopefully no-one makes more content that this :P
var CONTENT_LIMIT_PRO_BASE = exports.CONTENT_LIMIT_PRO_BASE = 9999999999999;


//////////////////
// WEBPACK FOOTER
// ./src/common/users/userConstants.js
// module id = 32
// module chunks = 0